module.exports = "/_next/static/images/56d2c6f050e6417771b9e62148af4a37-creditsprd-lg.jpg.webp";